module.exports = __webpack_public_path__ + "images/assets/a756176368474971666624f0b3d32b86.svg";